import BaseComponent from "../../../../../lib/components/BaseComponent";
import ButtonGroup from "../../../../../appl/view/components/buttons/ButtonGroup";

import {createRef} from "react";
import Loading from "../../../../../lib/components/images/Loading";
import Button from "../../../../../appl/view/components/buttons/Button";

class ButtonTest extends BaseComponent {

  render() {
    return <div className='sandbox-container flex flex-col gap-4'>
      <Button color="secondary"><Loading /></Button>
      <Button color="dark" widthFull>Test</Button>
      <Button color="dark">Test</Button>
      <Button size='large'  color="secondary" >Test</Button>
      <ButtonGroup color='primary' delimiterColor="white">
        <Button size='large'  ref={createRef()} className="bg-cn-color-primary" onClick={(e) => {
          alert('peng1');
        }}>dfsdfds</Button>
        <Button size='large'  ref={createRef()} className="bg-cn-color-primary">dfsfs</Button>
        <Button size='large'  ref={createRef()} color="primary" className="bg-cn-color-primary">dfsfs</Button>
        <Button size='large'  ref={createRef()} color="primary" className="bg-cn-color-primary" onClick={(e) => {
          alert('peng2');
        }}>dfsfs</Button>
        <Button size='large'  ref={createRef()} color="primary" className="bg-cn-color-primary">dsfsdf</Button>
      </ButtonGroup>
    </div>
  }
}

export default ButtonTest;
